import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { hasTranslation } from './PublishedLink';
import { localizePath, type Lang } from '../utils/locale';

/**
 * 言語切替は Router の basename の外へ出るため、Link ではなく <a> でフルロードする。
 * プリレンダー済みの <html lang> / title / canonical を確実に読み込ませる狙いもある。
 */
const LanguageSwitcher: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  const current = i18n.language as Lang;
  const other: Lang = current === 'en' ? 'ja' : 'en';

  if (!hasTranslation(pathname, other)) {
    return null;
  }

  return (
    <a
      href={localizePath(pathname, other)}
      hrefLang={other}
      lang={other}
      // lang={other} を付けた要素なので、読み上げ名も切替先の言語で書く
      aria-label={t('language.switchTo', { lng: other, language: t(`language.${other}`) })}
      className={className}
    >
      {t(`language.${other}`)}
    </a>
  );
};

export default LanguageSwitcher;
